import type { Middleware } from "openapi-fetch";

import { ROUTES } from "@/constants/routes";
import { tokenStorage } from "@/lib/storage/token";
import { refreshIfNeeded } from "@/services/api-client/utils";

const pendingRequests = new Map<string, Request>();

export const authMiddleware: Middleware = {
  async onRequest({ request, id }) {
    const token = tokenStorage.getToken();
    if (token) request.headers.set("Authorization", `Bearer ${token}`);
    pendingRequests.set(id, request.clone());
    return request;
  },
  async onResponse({ response, id }) {
    const original = pendingRequests.get(id);
    pendingRequests.delete(id);

    if (response.status !== 401) return undefined;

    const refreshed = await refreshIfNeeded();
    if (!refreshed) {
      tokenStorage.clear();
      window.location.href = ROUTES.LOGIN;
      return undefined;
    }

    if (!original) return undefined;
    const newToken = tokenStorage.getToken();
    if (newToken) original.headers.set("Authorization", `Bearer ${newToken}`);
    return fetch(original);
  },
};
